export const emailPattern = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  message: "Ingrese un correo válido",
};

export const phonePattern = {
  value: /^[\d\s()-]*\d[\d\s()-]*$/, // Patrón para permitir dígitos, espacios, guiones y paréntesis
  message: "Ingrese un número de teléfono válido",
};
